(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pj-catalog-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
document.querySelectorAll('.pj-context-nav details[open]').forEach(detail=>{if(!detail.contains(event.target))detail.open=false;});
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pj-context-nav details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});

document.querySelectorAll('.pj-context-nav a').forEach(link=>{
const url=new URL(link.href);url.hash='';
const sort=new URL(location.href).searchParams.get('sort_by');if(sort)url.searchParams.set('sort_by',sort);link.href=url.toString();
if(link.closest('.pj-filter-chip,.is-active'))link.setAttribute('aria-label',(document.documentElement.lang==='ar'?'إزالة':'Remove')+' '+link.textContent.trim());
});

function pjInitFrameFilters(){
document.querySelectorAll('[data-pj-frame-filters]').forEach(root=>{
if(root.dataset.ready)return;
const cards=[...document.querySelectorAll('[data-pj-frame]')];
if(!cards.length)return;
root.dataset.ready='true';
const labels=JSON.parse(root.querySelector('[data-frame-labels]').textContent);
const normalize=value=>{const s=value.toLowerCase().replace(/,/g,'.');const m=s.match(/([\d.]+)\s*[x×]\s*([\d.]+)/);if(!m)return value.trim();const dims=[Number(m[1]),Number(m[2])].sort((a,b)=>a-b);return dims.join(' × ')+' cm'+(s.includes('without glass')?' · '+(document.documentElement.lang==='ar'?'بدون زجاج':'Without glass'):'');};
const rows=cards.map(card=>({card,container:card.closest('.grid__item')||card,sizes:JSON.parse(card.dataset.pjFrameSizes||'[]').map(normalize),colour:card.dataset.pjFrameColour,style:card.dataset.pjFrameStyle}));
const selects=[...root.querySelectorAll('[data-frame-filter]')];
selects.forEach(select=>{
const key=select.dataset.frameFilter;
const values=[...new Set(rows.flatMap(row=>key==='size'?row.sizes:[row[key]]))].filter(Boolean).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=labels[value]||value;select.append(option);});
select.addEventListener('change',update);
});
function update(){
const selected=Object.fromEntries(selects.map(select=>[select.dataset.frameFilter,select.value]));
let count=0;
rows.forEach(row=>{const show=(!selected.size||row.sizes.includes(selected.size))&&(!selected.colour||row.colour===selected.colour)&&(!selected.style||row.style===selected.style);row.container.hidden=!show;row.container.classList.toggle('pj-filter-hidden',!show);if(show)count++;});
root.querySelector('[data-frame-result]').textContent=labels.result.replace('[count]',count).replace('[total]',rows.length);
root.querySelector('[data-frame-empty]').hidden=count!==0;
const chips=root.querySelector('[data-frame-chips]');chips.replaceChildren();
selects.filter(s=>s.value).forEach(select=>{
const button=document.createElement('button');button.type='button';button.className='pj-filter-chip-button';
button.textContent=select.options[select.selectedIndex].text+' ×';
button.setAttribute('aria-label',labels.remove+' '+select.options[select.selectedIndex].text);
button.addEventListener('click',()=>{select.value='';update();select.focus();});chips.append(button);
});
root.querySelector('[data-frame-reset]').disabled=!selects.some(s=>s.value);
}
root.querySelector('[data-frame-reset]').addEventListener('click',()=>{selects.forEach(s=>s.value='');update();});
update();
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',pjInitFrameFilters);else pjInitFrameFilters();
document.addEventListener('shopify:section:load',pjInitFrameFilters);

let pjFilterRequest;
async function pjUpdateCollection(href,push=true,focusLabel=''){
const host=document.querySelector('[data-pj-collection]');
if(!host)return;
if(pjFilterRequest)pjFilterRequest.abort();
const controller=new AbortController();pjFilterRequest=controller;
const url=new URL(href,location.href);url.hash='';
const y=window.scrollY;
host.setAttribute('aria-busy','true');
try{
const response=await fetch(url,{signal:controller.signal});
if(!response.ok)throw new Error('Filter request failed');
const page=new DOMParser().parseFromString(await response.text(),'text/html');
const incoming=page.querySelector('[data-pj-collection]');
if(!incoming)throw new Error('Missing collection');
const oldNav=host.querySelector('#PJFilters'),newNav=incoming.querySelector('#PJFilters');
const openGroups=new Map([...host.querySelectorAll('#PJFilters details')].map(d=>[d.querySelector('summary').textContent.trim(),d.open]));
if(oldNav&&newNav){
const oldTags=location.pathname.split('/collections/')[1]?.split('/')[1]?.split('+')||[];
const newTags=url.pathname.split('/collections/')[1]?.split('/')[1]?.split('+')||[];
const base=url.pathname.split('/collections/')[0]+'/collections/'+url.pathname.split('/collections/')[1].split('/')[0];
oldNav.querySelectorAll('details').forEach(detail=>{
detail.querySelectorAll('a').forEach(a=>{
const linked=new URL(a.href).pathname.split('/collections/')[1]?.split('/')[1]?.split('+')||[];
const tag=linked.find(t=>!oldTags.includes(t))||oldTags.find(t=>!linked.includes(t));
if(!tag)return;
const active=newTags.includes(tag),next=active?newTags.filter(t=>t!==tag):[...newTags,tag];
a.href=base+(next.length?'/'+next.join('+'):'')+url.search;
a.parentElement.classList.toggle('is-active',active);
a.setAttribute('aria-label',(active?(document.documentElement.lang==='ar'?'إزالة ':'Remove '):'')+a.textContent.trim());
});
});
newNav.querySelectorAll('details').forEach(d=>d.remove());
oldNav.querySelectorAll('details').forEach(d=>newNav.append(d));
oldNav.replaceWith(newNav);newNav.querySelectorAll('details').forEach(d=>{const key=d.querySelector('summary').textContent.trim();if(openGroups.has(key))d.open=openGroups.get(key);});}
const oldCount=host.querySelector('[data-pj-result-count]'),newCount=incoming.querySelector('[data-pj-result-count]');if(oldCount&&newCount)oldCount.textContent=newCount.textContent;
const oldGrid=host.querySelector('[data-pj-results]'),newGrid=incoming.querySelector('[data-pj-results]');
if(oldGrid&&newGrid)oldGrid.replaceWith(newGrid);
host.querySelector('.pagination')?.remove();
const pagination=incoming.querySelector('.pagination');if(pagination)host.append(pagination);
const oldTitle=host.querySelector('h1'),newTitle=incoming.querySelector('h1');if(oldTitle&&newTitle)oldTitle.innerHTML=newTitle.innerHTML;
document.title=page.title;
if(push)history.pushState({pjFilter:true},'',url);
const sort=host.querySelector('#SortBy');if(sort){const wanted=url.searchParams.get('sort_by')||sort.getAttribute('data-default-sort')||'manual';sort.value=[...sort.options].some(o=>o.value===wanted)?wanted:sort.options[0].value;}
if(focusLabel){
const link=[...host.querySelectorAll('#PJFilters a')].find(a=>a.textContent.trim()===focusLabel);
if(link){const group=link.closest('details');if(group&&!group.open)group.querySelector('summary').focus({preventScroll:true});else link.focus({preventScroll:true});}
else {const area=host.querySelector('#PJFilters');area?.setAttribute('tabindex','-1');area?.focus({preventScroll:true});}
}
window.scrollTo({top:y,behavior:'instant'});
}catch(error){if(error.name!=='AbortError'){host.querySelector('[data-pj-filter-error]')?.remove();const notice=document.createElement('p');notice.dataset.pjFilterError='';notice.setAttribute('role','alert');notice.textContent=document.documentElement.lang==='ar'?'تعذّر تحديث النتائج. جرّب مرة ثانية.':'Could not update results. Please try again.';host.querySelector('#PJFilters')?.append(notice);}}
finally{if(pjFilterRequest===controller)host.removeAttribute('aria-busy');}
}
document.addEventListener('click',event=>{
const link=event.target.closest('.pj-context-nav a');
if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
event.preventDefault();event.stopImmediatePropagation();
const url=new URL(link.href);url.hash='';
const sort=new URL(location.href).searchParams.get('sort_by');if(sort)url.searchParams.set('sort_by',sort);
url.searchParams.delete('page');
const group=link.closest('details');if(group)group.open=false;
pjUpdateCollection(url,true,link.textContent.trim());
},true);
document.addEventListener('change',event=>{
if(event.target.id!=='SortBy'||!document.querySelector('.pj-context-nav'))return;
event.stopImmediatePropagation();
const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');pjUpdateCollection(url);
},true);
window.addEventListener('popstate',()=>{if(document.querySelector('.pj-context-nav'))pjUpdateCollection(location.href,false);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pj-mobile-purchase"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(){
  document.querySelectorAll('[data-pj-mobile-buy]').forEach(function(bar){
   if(bar.dataset.bound)return;
   var root=document.getElementById('ProductSection-'+bar.dataset.section);
   if(!root)return;
   var form=root.querySelector('#AddToCartForm');
   var submit=root.querySelector('[name="add"]');
   var price=root.querySelector('[id^="ProductPrice-"]');
   var action=bar.querySelector('[data-pj-mobile-action]');
   var displayPrice=bar.querySelector('[data-pj-mobile-price]');
   if(!form||!submit||!price)return;
   bar.dataset.bound='true';
   var mq=matchMedia('(max-width:749px)');
   var scheduled=false;
   function missingPhoto(){return Array.from(form.querySelectorAll('input[type="file"][required]')).find(function(input){return !input.disabled&&(!input.files||!input.files.length);});}
   function update(){
    scheduled=false;
    var rect=submit.getBoundingClientRect();
    var heading=root.querySelector('h1');
    var editing=document.activeElement&&form.contains(document.activeElement)&&document.activeElement.matches('input,textarea,select');
    var visible=rect.top<innerHeight&&rect.bottom>80;
    bar.hidden=!mq.matches||visible||!!editing||!!document.querySelector('[role="dialog"][aria-modal="true"]:not([hidden])')||(heading&&heading.getBoundingClientRect().top>innerHeight);
    displayPrice.textContent=price.textContent.trim();
    var unavailable=submit.disabled&&!missingPhoto();
    action.disabled=unavailable;
    action.textContent=unavailable?submit.textContent.trim():(missingPhoto()?action.dataset.upload:action.dataset.review);
   }
   function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
   action.addEventListener('click',function(){
    var upload=missingPhoto();
    var target=upload||submit;
    target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    target.focus({preventScroll:true});
   });
   addEventListener('scroll',schedule,{passive:true});
   addEventListener('resize',schedule,{passive:true});
   form.addEventListener('change',schedule);
   form.addEventListener('input',schedule);
   form.addEventListener('focusin',schedule);
   form.addEventListener('focusout',schedule);
   new MutationObserver(schedule).observe(price,{childList:true,subtree:true,characterData:true});
   new MutationObserver(schedule).observe(submit,{attributes:true,childList:true,subtree:true,characterData:true});
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
